module.exports = __webpack_public_path__ + "static/nyoutritious-thumbnail-291cfabc23992749480a810149110b01.jpeg";